import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import "bootstrap/dist/css/bootstrap.min.css";
import './App.scss';

import { useDispatch } from "react-redux";
import { createIp, getIps, 
  // findIpByName 
} from "./actions/ipsActions"; /* deleteAllIps, */

import utils from './utils';


import Navigation from './components/navigation/navigation.component';
import Router from './components/navigation/router.component';

import owl from './assets/images/owl.png';

/**
 * 1. Check cookie
 * 2a. Has one - stop, this is counted
 * 2b. No cookie - ask for Ip.
 * 3a. error on getting Ip - setting cookie with unique name, step 4
 * 3b. getting ip - setting cookie with name of the ip, step 4.
 * 4. ask the mongo for an "ip" with the name. 
 *   If there is none - create.
 * 5. Ask mongo for all ips - this is the counter value;  
 */





export default function App(props) { 
  const [action, store] = [props.action, props.store];
  const { pathname, hash, key } = useLocation();
  // const addr = 'https://ipinfo.io/json?token=b6af1c438969b3';
  const dispatch = useDispatch();
  
  // const getIpCb = (res, err) => {
  //   if (
  //     ( ( !err && !res ) || ( err && (
  //       err.message === 'Failed to fetch' ||
  //       err.message === 'NetworkError when attempting to fetch resource.') )) ||
  //     ( res && res.status === 429 )
  //   ) {
  //     let id = utils.guid();
  //     setNewUser(id);
  //     return;
  //   }
  //   if (res) {
  //     let id = res.ip.split('.').join('-');
  //     setNewUser(id);
  //   }
  // }

  const setNewUser = async (id) => {

    // utils.setCookie('auduser', id, 3650);
    // let dbUser = await dispatch(findIpByName(id));
    // if (!dbUser.success && dbUser.message.startsWith('Not found Ip with name')) {
    if ( window.location.href.indexOf('localhost') < 0 ) {
      await dispatch(createIp(id));
      await dispatch(getIps());
    }
    // }
  }

  // const myIP = async (url) => {
  //   // Default options are marked with *
  //   const response = await fetch(url, {
  //     mode: 'no-cors', // no-cors, *cors, same-origin
  //     cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
  //     credentials: 'omit', // include, *same-origin, omit
  //     headers: {
  //       'Content-Type': 'application/json'
  //       // 'Content-Type': 'application/x-www-form-urlencoded',
  //     },
  //     referrerPolicy: 'no-referrer', // no-referrer, *client
  //   });
  //   return await response.json(); // parses JSON response into native JavaScript objects
    
    
  // }

  // const initCounterCheck = async () => {
  //   let user = utils.getCookie('auduser');
  //   if ( user !== "") {
  //     await dispatch(getIps());
  //     return null;
  //   }
  //   myIP(addr).then((res) => {
  //     if (res.message) {
  //       getIpCb(null, res);
  //     } else {
  //       getIpCb(res);
  //     }
  //   }).catch( err => {
  //     getIpCb(null, err)
  //   });
  // }

  useEffect(() => {
    // initCounterCheck();
    let id = utils.guid();
    setNewUser(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
        
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
      document.querySelector('.content').scrollTop = 0;
    
    // else scroll to id
    } else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        element && element.scrollIntoView();
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change

  const getHamburgerClass = () => {
    return "hamburger" + (store.getState().menuOpen ? " open" : "")
  }
  const getNavClass = () => {
    return "nav" + (store.getState().menuOpen ? " open" : "")
  }
  const toggleMenu = () => {
    action('TOGGLE_MENU', !store.getState().menuOpen)
  }
  const updateLink = (link) => {
    store.getState().currentText != null && action('UPDATE_CURRENT_TEXT', null);
    props.action('UPDATE_LINK', link)
  }
    return (
      <div className="root d-flex flex-column">
        <div className="d-flex header p-2">
          <Link to={'/'} onClick={() => updateLink('/')} >
              <img src={owl} alt="Owl" className="header_logo" />
          </Link>
          
          <p>Bonvenon al retejo de Tatjana Auderskaja</p>
          <span>
          </span>
          <div className={getHamburgerClass()} onClick={() => toggleMenu()}>
            <div className="icon"></div>
          </div>
        </div>
        <div className="d-flex main overflow-auto">
          <div className={getNavClass()}>
            <Navigation store={props.store} action={props.action}></Navigation>
          </div>
          <div className="content col p-3 overflow-auto flex">
            <Router store={props.store} action={props.action}></Router>
          </div>
        </div>
      </div>
    );
}